<sl-label class="description" multiline i18n>Just enter the address of the member you'd like to invite, select the new
  user's security role and we'll send an email.</sl-label>
<div class="mt-7">
  <sl-input i18n-placeholder placeholder="Type or paste the email address here" [(ngModel)]="invitee"></sl-input>
  <sl-select class="mt-4" slot="suffix" [(ngModel)]="role" hoist>
    <sl-menu-item value="ADMIN" i18n="@@Administrator">Administrator</sl-menu-item>
    <sl-menu-item value="MANAGEMENT" i18n="@@Manager">Manager</sl-menu-item>
    <sl-menu-item value="USER" i18n="@@User">Trusted Employee</sl-menu-item>
    <sl-menu-item value="EMPLOYEE" i18n="@@Employee">Employee</sl-menu-item>
  </sl-select>
</div>
<sl-label class="mt-2" size="small" color="medium" multiline *ngIf="hasPricePerResource()">{{pricePerResourceDescription}}</sl-label>
<div class="text-right mt-8">
  <sl-button i18n class="mr-4" (click)="cancel()">Cancel</sl-button>
  <sl-button type="primary" i18n (click)="send()">Send invitation</sl-button>
</div>